import styles from "./ButtonStack.module.scss";

export const ButtonStack = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.buttonStack}>{children}</div>;
};
